import React, { useState, useEffect, useRef } from 'react';
import { Calendar } from '@progress/kendo-react-dateinputs';
import styled from 'styled-components';

const CustomCalendar = props => {
  const { onChange, value, max } = props;
  const [showCalendar, setShowCalendar] = useState(true);
  const calendarRef = useRef<HTMLDivElement>(null);

  const handleDateChange = event => {
    onChange({
      value: event.target.value,
      syntheticEvent: event.syntheticEvent,
    });
    setShowCalendar(false);
  };

  const handleClickOutside = event => {
    if (calendarRef.current && !calendarRef.current.contains(event.target)) {
      setShowCalendar(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  return (
    <Wrapper ref={calendarRef}>
      {showCalendar && (
        <Calendar
          className="custom-datepicker"
          value={props.value}
          onChange={handleDateChange}
          navigation={false}
          max={max}
        />
      )}
    </Wrapper>
  );
};
const Wrapper = styled.div`
  .k-calendar-infinite .k-calendar-view {
    height: 316px !important;
  }
  @media (min-width: 100px) and (max-width: 1365px) {
    .k-calendar-infinite .k-calendar-view {
      height: 280px !important;
    }
  }
  .custom-datepicker {
    background-color: #222222 !important;
    font-family: 'Lato';
    .k-content {
      background: #222222 !important;
    }
  }

  .k-calendar-infinite .k-calendar-view::after {
    box-shadow: 0 0 38px 19px #222222 !important;
  }
  .k-button {
    color: rgb(255 255 255 / 87%);
    font-family: 'Lato';
    &:hover {
      background: #eeeeee !important;
      color: #000000;
    }
  }

  .k-calendar .k-calendar-th {
    color: #7d7d7d;
  }
  .k-calendar .k-link {
    color: rgb(255 255 255 / 87%);
    font-family: 'Lato';
    &:hover {
      background: #eeeeee !important;
    }
  }
  .k-calendar .k-calendar-td.k-selected .k-link {
    &:hover {
      color: #0d6efd !important;
    }
  }
  @media (min-width: 576px) and (max-width: 767px) {
    .k-calendar-infinite .k-calendar-view {
      width: 265px;
    }
  }
  @media (min-width: 320px) and (max-width: 575px) {
    .k-calendar-infinite .k-calendar-view {
      width: 230px;
    }
  }
  @media (min-width: 100px) and (max-width: 319px) {
    .k-calendar-infinite .k-calendar-view {
      width: 190px;
    }
  }
`;

export default CustomCalendar;
